module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level is-mobile lxm-menu"
  }, [_c('p', {
    staticClass: "level-item has-text-left lxm-menu__title"
  }, [_vm._v("\n      " + _vm._s(_vm.teamName) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "level-item has-text-right lxm-menu__button",
    on: {
      "click": _vm.buttonClick
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/main/menu.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lxm-menu-placeholder"
  }), _vm._v(" "), _c('lxm-menu-panel', {
    ref: "menuPanel"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e3325e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e3325e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmMenu.vue
// module id = 855
// module chunks = 0